import { expected } from '@aloft/toolkit-shared';

import { FilterTableFieldName } from '../../../FilterDrawer/types.ts';

const fieldNameToOptions: {
  [key in FilterTableFieldName]?: { label: string; value: string }[];
} = {
  'search.filters.propertySubType': [
    { label: 'Manufactured Home', value: 'Manufactured Home' },
    { label: 'Multi Family', value: 'Multifamily Property' },
    { label: 'Single Family Residence', value: 'Single Family Residence' },
    { label: 'Condominium/Townhome', value: 'Condominium/Townhome' },
    { label: 'Lots and Land', value: 'Lots and Land' },
  ],
  'search.filters.view': [
    { label: 'Bay', value: 'Bay' },
    { label: 'Beach', value: 'Beach' },
    { label: 'Bridge(s)', value: 'Bridge(s)' },
    { label: 'Canal', value: 'Canal' },
    { label: 'Canyon', value: 'Canyon' },
    { label: 'City', value: 'City' },
    { label: 'City Lights', value: 'City Lights' },
    { label: 'Creek/Stream', value: 'Creek/Stream' },
    { label: 'Desert', value: 'Desert' },
    { label: 'Downtown', value: 'Downtown' },
    { label: 'Forest', value: 'Forest' },
    { label: 'Garden', value: 'Garden' },
    { label: 'Golf Course', value: 'Golf Course' },
    { label: 'Hills', value: 'Hills' },
    { label: 'Lake', value: 'Lake' },
    { label: 'Marina', value: 'Marina' },
    { label: 'Meadow', value: 'Meadow' },
    { label: 'Mountain(s)', value: 'Mountain(s)' },
    { label: 'Neighborhood', value: 'Neighborhood' },
    { label: 'None', value: 'None' },
    { label: 'Ocean', value: 'Ocean' },
    { label: 'Orchard', value: 'Orchard' },
    { label: 'Other', value: 'Other' },
    { label: 'Panoramic', value: 'Panoramic' },
    { label: 'Park/Greenbelt', value: 'Park/Greenbelt' },
    { label: 'Pasture', value: 'Pasture' },
    { label: 'Pond', value: 'Pond' },
    { label: 'Pool', value: 'Pool' },
    { label: 'Ridge', value: 'Ridge' },
    { label: 'River', value: 'River' },
    { label: 'Rural', value: 'Rural' },
    { label: 'See Remarks', value: 'See Remarks' },
    { label: 'Skyline', value: 'Skyline' },
    { label: 'Territorial', value: 'Territorial' },
    { label: 'Trees/Woods', value: 'Trees/Woods' },
    { label: 'Valley', value: 'Valley' },
    { label: 'Vineyard', value: 'Vineyard' },
    { label: 'Water', value: 'Water' },
    { label: 'Farm', value: 'Farm' },
    { label: 'Harbor', value: 'Harbor' },
    { label: 'Inlet', value: 'Inlet' },
    { label: 'Private', value: 'Private' },
    { label: 'Scenic', value: 'Scenic' },
    { label: 'Sound', value: 'Sound' },
    { label: 'Street', value: 'Street' },
  ],
  'search.filters.status': [
    { label: 'Active', value: 'Active' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Sold', value: 'Sold' },
  ],
  'search.matchCriteria.saleDate': [
    { label: 'Last', value: 'lasting_range' },
    { label: 'Range', value: 'min_max_range' },
  ],
  'search.matchCriteria.salePrice': [
    { label: 'Range', value: 'min_max_range' },
    { label: 'Within', value: 'percentage_range' },
  ],
  'search.matchCriteria.gla': [
    { label: 'Range', value: 'min_max_range' },
    { label: 'Within', value: 'percentage_range' },
  ],
  'search.matchCriteria.lotSize': [
    { label: 'Range', value: 'min_max_range' },
    { label: 'Within', value: 'percentage_range' },
  ],
  'search.matchCriteria.yearBuilt': [
    { label: 'Exact', value: 'exact' },
    { label: 'Range', value: 'min_max_range' },
    { label: 'Within', value: 'value_range' },
  ],
  'search.matchCriteria.bedrooms': [
    { label: 'Exact', value: 'exact' },
    { label: 'Range', value: 'min_max_range' },
    { label: 'Within', value: 'value_range' },
  ],
  'search.matchCriteria.fullBaths': [
    { label: 'Exact', value: 'exact' },
    { label: 'Range', value: 'min_max_range' },
    { label: 'Within', value: 'value_range' },
  ],
  'search.matchCriteria.stories': [
    { label: 'Exact', value: 'exact' },
    { label: 'Range', value: 'min_max_range' },
    { label: 'Within', value: 'value_range' },
  ],
  'search.matchCriteria.garageSpaces': [
    { label: 'Exact', value: 'exact' },
    { label: 'Range', value: 'min_max_range' },
    { label: 'Within', value: 'value_range' },
  ],
};

export function getEnumOptions({
  name,
}: {
  name: FilterTableFieldName;
}): { label: string; value: string }[] {
  if (!(name in fieldNameToOptions)) {
    console.error(`No options for :${name}`);
    return [];
  }
  return expected(fieldNameToOptions[name]);
}
